export default __webpack_public_path__ + "static/imageog-40304bfd16e3b9e94ce653521e48b790.png";